module.exports = __webpack_public_path__ + "static/media/23.f1644057.jpg";